const widthSetOptins = ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'];
const dateTypeOptions = ['YYYY-MM', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD HH:mm:ss'];
const controlCellOptions = [{
  label: '单行文本',
  value: 'text'
}, {
  label: '单选',
  value: 'radio'
}, {
  label: '日期选择',
  value: 'date'
}];
const controlColOptions = [{
  label: '单行文本',
  value: 'text'
}, {
  label: '单选',
  value: 'radio'
}, {
  label: '日期选择',
  value: 'date'
}, {
  label: '日期选择',
  value: 'date'
}];
const fontSizeSelectOption = ['默认字号', '5', '5.5', '6.5', '7.5', '8', '9', '10', '10.5', '11', '12', '14', '16', '18', '20', '22', '26', '28'];
const fontFamilySelectOption = ['默认字体', '宋体', '楷体', '黑体', 'Trebuchet MS', 'Times New Roman'];
export { widthSetOptins, dateTypeOptions, controlCellOptions, controlColOptions, fontSizeSelectOption, fontFamilySelectOption };